import { atoms, Link } from '@zapier/marketing-ui';
import { addParamsToUrl } from '@zapier/url-utils';
import { urls } from '@zapier/identity-utils';

import { QueryParams } from '../../types';

type Props = {
  queryParams: QueryParams;
};

export function NoAccountLink({ queryParams }: Props) {
  return (
    <p
      className={`${atoms.bodySM} ${atoms.textNeutral800} ${atoms.textCenter}`}
    >
      Don&apos;t have a Zapier account yet?{' '}
      <Link href={addParamsToUrl(urls.SIGNUP_URL, queryParams)}>Sign Up</Link>
    </p>
  );
}
